var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewIsLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#008CFF",
    d: "M5 7h9.394a3 3 0 013 3v5.36a3 3 0 01-3 3h-1.725 0s.237 1.834 1.193 2.79c0 0-3.609 1.296-5.201-2.79l-3.709-.06A2.999 2.999 0 012 15.3V10a3 3 0 013-3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#008CFF",
    strokeLinecap: "round",
    d: "M5.081 10.469h4.908m-4.908 3.2h9.155M14 4h1a5 5 0 015 5h0m-6-8h2a7 7 0 017 7h0"
  }))));
}
export default SvgReviewIsLive;